import React from 'react'
import ScheduleContainer from '../../containers/schedulemng/ScheduleContainer'

const ScheduleViewPage = () => {
    

  return (
    <ScheduleContainer />
  )
}

export default ScheduleViewPage